import script from "./post.vue?vue&type=script&setup=true&lang=js"
export * from "./post.vue?vue&type=script&setup=true&lang=js"

import "./post.vue?vue&type=style&index=0&id=3fbc88de&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbc88de"]])

export default __exports__